import React, { Component } from 'react';

import { SCREEN_ID_UTILITY_SETUP_PROVIDER_PLAN_NO_CONTRACT } from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withLocationQuery from 'client/helpers/withLocationQuery';

import branch from 'client/core/branch';
import UtilityPartnerActions from 'client/actions/UtilityPartner';
import UtilityActivationActions from 'client/actions/UtilityActivation';

import SrUtilitySetupPage from 'client/components/SrUtilitySetup/SrUtilitySetupPage';
import SrUtilitySetupProviderPlan from 'client/components/SrUtilitySetup/SrUtilitySetupProviderPlan';

@withTransitionHook
@withLocationQuery
@withScreenId(SCREEN_ID_UTILITY_SETUP_PROVIDER_PLAN_NO_CONTRACT)
@withScrollToTop
@branch(({ match }) => ({
  utilityActivation: ['utilityActivations', 'byShortId', match.params.utilityActivationShortId],
  utilityPartner: ['utilityPartners', 'bySlug', match.params.partnerSlug],
}))
class UtilitySetupProviderPlanNoContractPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Utility Setup | No Contract Plans',
  });

  static fetchData(match, inject) {
    return Promise.all([
      UtilityPartnerActions.getBySlug(inject, {
        slug: match.params.partnerSlug,
      }),
      UtilityActivationActions.getByShortId(inject, {
        utilityActivationShortId: match.params.utilityActivationShortId,
      }),
    ]);
  }

  _refreshUtilityActivation = () => {
    const { dispatch, utilityActivation } = this.props;
    return dispatch(UtilityActivationActions.getByShortId, {
      utilityActivationShortId: utilityActivation.shortId,
      forceRefresh: true,
    });
  };

  render() {
    const { utilityPartner, utilityActivation, match, history, locationQuery } = this.props;

    const utilityTypeLabel = match.params.utilityTypeLabel;

    if (!utilityPartner || !utilityActivation) {
      return null;
    }

    const utilityActivationItem = utilityActivation.items.find(
      (item) => item.type.label.toLowerCase() === utilityTypeLabel,
    );

    return (
      <SrUtilitySetupPage
        addressDisplay={utilityActivation.address?.display}
        utilityPartner={utilityPartner}
        utilityActivationId={utilityActivation.id}
        logoUrl={utilityPartner.logoUrl}
        backButtonText="Back"
        backButtonUrl={`/utility-setup/${utilityPartner.slug}/${utilityActivation.shortId}/${utilityTypeLabel}/plan`}
      >
        <SrUtilitySetupProviderPlan
          history={history}
          locationQuery={locationQuery}
          utilityPartner={utilityPartner}
          utilityActivation={utilityActivation}
          utilityActivationItem={utilityActivationItem}
          onRefreshUtilityActivation={this._refreshUtilityActivation}
          isNoContractPlans
        />
      </SrUtilitySetupPage>
    );
  }
}

UtilitySetupProviderPlanNoContractPage.displayName = 'UtilitySetupProviderPlanNoContractPage';

export default UtilitySetupProviderPlanNoContractPage;
